document.addEventListener('DOMContentLoaded', function() {
  const quantitySelectors = document.querySelectorAll('.product-quantity');

  quantitySelectors.forEach(selector => {
    const tagsData = selector.dataset.tags;
    if (!tagsData) {
      console.error("Aucun tag trouvé pour cet élément.");
      return; 
    }

    const tags = tagsData.split(',');
    const plusButton = selector.querySelector('.qty-plus');
    const minusButton = selector.querySelector('.qty-minus');
    const quantityInput = selector.querySelector('.qty-selector');

    let step = 1; // Valeur par défaut
    
    // Fonction pour afficher le pop-up
           const showPopup = () => {
               const popup = document.getElementById('quantity-popup');
               popup.style.display = 'block';
           };

           // Fonction pour fermer le pop-up
           const closePopup = () => {
               const popup = document.getElementById('quantity-popup');
               popup.style.display = 'none';
           };

    // Utilisation de switch case pour déterminer le step
    for (const tag of tags) {
      switch (tag) {
        case 'vente2': step = 2; break;
        case 'vente5': step = 5; break;
        case 'vente6': step = 6; break;
        case 'vente8': step = 8; break;
        case 'vente10': step = 10; break;
        case 'vente12': step = 12; break;
        case 'vente15': step = 15; break;
        case 'vente16': step = 16; break;
        case 'vente18': step = 18; break;
        case 'vente20': step = 20; break;
        case 'vente24': step = 24; break;
      }
    }

    // Fonction pour augmenter la quantité
    const increaseQuantity = () => {
      let currentValue = parseInt(quantityInput.value, 10) || 0; // Valeur par défaut
      currentValue += step -1; // Ajoute le step
      quantityInput.value = Math.min(currentValue, 999); // Limite à 999
    };

    // Fonction pour diminuer la quantité
    const decreaseQuantity = () => {
      let currentValue = parseInt(quantityInput.value, 10) || 0; // Valeur par défaut
      const minValue = Math.max(step, 1); // Minimal basé sur le step ou 1
      currentValue -= step -1; // Soustrait le step 
      quantityInput.value = Math.max(currentValue, minValue); // Limite à minValue
    };

    // Ajout des événements des boutons
           plusButton.addEventListener('click', () => {
               increaseQuantity();
                   if (step !== 1) {
                      showPopup(); // Afficher le pop-up
                    }
           });

           minusButton.addEventListener('click', () => {
               decreaseQuantity();
                    if (step !== 1) {
                      showPopup(); // Afficher le pop-up
                    }
           });

           // Écouteur d'événement pour fermer le pop-up
           document.getElementById('close-popup').addEventListener('click', closePopup);
       });
});
